import { useProfitWellUserSync } from '../hooks/profitwell/useProfitWellUserSync'
import { useIsFlowpage } from '../../../hooks/useIsFlowpage/useIsFlowpage'
import Script from 'next/script'

export const PROFITWELL_API_PUBLIC_TOKEN = 'c5573c05be71e072fc66c8e3635c650c'

/**
 * [ProfitWell](https://www.profitwell.com/churn-reduction-software) is a third-party service that provides subscription analytics.
 *
 * There should only be a single instance of this component loaded at a time.
 */
export const ProfitWell = (): JSX.Element => {
  const isFlowpage = useIsFlowpage()
  useProfitWellUserSync({ disabled: isFlowpage })

  if (isFlowpage) return <></>

  return (
    <Script
      id="profitwell-js"
      data-testid="profitwell-js"
      data-pw-auth={PROFITWELL_API_PUBLIC_TOKEN}
      strategy="afterInteractive"
    >
      {`(function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)};
        a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+
        s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);
        })(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');


        // Start the script now, user_email is identified in ProfitWell component
        profitwell('start',{});
      `}
    </Script>
  )
}
//
